import React, { Component } from 'react';
import { IconButton, Menu, MenuItem, ListItemText } from '@mui/material';
import { Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Button } from "@mui/material";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { toast } from "react-toastify";

const ITEM_HEIGHT = 48;
let ConsentPreview;

class VerticalMenu extends Component {
  constructor(props) {
    super(props);

    this.state = { ...this.props.state, deleteDialogOpen: false, disableDialogOpen: false }
  }

  handleContextClick = (event, n) => {
    const { t } = this.props;
    event.preventDefault();
    let disabledText;
    if ((n && n.is_enabled) === 'true' || (n && n.is_enabled) === true) {
      disabledText = t('Users.DisableActions');
    } else {
      disabledText = t('Report.inActive.Enable');
    }
    this.setState({
      anchorEl: event.currentTarget,
      selectedRowId: n.id,
      disabledText: disabledText,
    });
  };

  handleContextClose = (event) => {
    event.preventDefault();
    this.setState({ anchorEl: null, selectedRowId: null });
  };

  handleView = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );
    const patientaccount = this.props.account.filter(
      (x) => x.id === selectedObject.parent_account_id
    );
    ConsentPreview =
      patientaccount &&
      patientaccount[0].legal_compliance &&
      patientaccount[0].legal_compliance.legal_compliance_doctwo_url;
    const filteredObject = {
      expanded: 'panel0',
      selectedTab: 0,
      location_id: selectedObject.location_id,
      showNewUserDialog: true,
      operation: 'View',
      patient_notes: selectedObject.notes,
      user: selectedObject,
      parent_account_id: selectedObject.parent_account_id,
      first_name: selectedObject.first_name,
      last_name: selectedObject.last_name,
      email: selectedObject.contacts[0].email,
      avatarPreview: selectedObject.picture_url,
      phone: selectedObject.contacts && selectedObject.contacts[0].phone,
      Nemail: selectedObject.email_notification,
      Nsms: selectedObject.sms_notification,
      Npush: selectedObject.push_notification,
      box_id: selectedObject.box_id ? selectedObject.box_id : null,
      dob: selectedObject.dob_str ? selectedObject.dob_str : null,
      LCPreview:
        selectedObject.legaldocs &&
        selectedObject.legaldocs.docmanual_policy_url,
      IsActive: selectedObject.legaldocs && selectedObject.legaldocs.is_active,
      IsConsent: selectedObject.is_consent_accepted,
      signature:
        selectedObject.legaldocs && selectedObject.legaldocs.signature_url,
      signature_time:
        selectedObject.legaldocs && selectedObject.legaldocs.signature_date,
      Locations: selectedObject.customerLocations,
      address1:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.address_line_1 === '' ||
            selectedObject.address.address_line_1 === 'null' ||
            selectedObject.address.address_line_1 === null ||
            selectedObject.address.address_line_1 === undefined ||
            selectedObject.address.address_line_1 === 'undefined'
            ? ''
            : selectedObject.address.address_line_1),
      address2:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.address_line_2 === '' ||
            selectedObject.address.address_line_2 === 'null' ||
            selectedObject.address.address_line_2 === null ||
            selectedObject.address.address_line_2 === undefined ||
            selectedObject.address.address_line_2 === 'undefined'
            ? ''
            : selectedObject.address.address_line_2),
      zip:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.zip === '' ||
            selectedObject.address.zip === 'null' ||
            selectedObject.address.zip === null ||
            selectedObject.address.zip === undefined ||
            selectedObject.address.zip === 'undefined'
            ? ''
            : selectedObject.address.zip),
      state:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.state === '' ||
            selectedObject.address.state === 'null' ||
            selectedObject.address.state === null ||
            selectedObject.address.state === undefined ||
            selectedObject.address.state === 'undefined'
            ? ''
            : selectedObject.address.state),
      city:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.city === '' ||
            selectedObject.address.city === 'null' ||
            selectedObject.address.city === null ||
            selectedObject.address.city === undefined ||
            selectedObject.address.city === 'undefined'
            ? ''
            : selectedObject.address.city),
      room_no:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.room_no === '' ||
            selectedObject.address.room_no === 'null' ||
            selectedObject.address.room_no === null ||
            selectedObject.address.room_no === undefined ||
            selectedObject.address.room_no === 'undefined'
            ? ''
            : selectedObject.address.room_no),
      bed_no:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.bed_no === '' ||
            selectedObject.address.bed_no === 'null' ||
            selectedObject.address.bed_no === null ||
            selectedObject.address.bed_no === undefined ||
            selectedObject.address.bed_no === 'undefined'
            ? ''
            : selectedObject.address.bed_no),
      source_location:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.source_location === '' ||
            selectedObject.address.source_location === 'null' ||
            selectedObject.address.source_location === null ||
            selectedObject.address.source_location === undefined ||
            selectedObject.address.source_location === 'undefined'
            ? ''
            : selectedObject.address.source_location),
      destination_location:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.destination_location === '' ||
            selectedObject.address.destination_location === 'null' ||
            selectedObject.address.destination_location === null ||
            selectedObject.address.destination_location === undefined ||
            selectedObject.address.destination_location === 'undefined'
            ? ''
            : selectedObject.address.destination_location),
      location_notes:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.location_notes === '' ||
            selectedObject.address.location_notes === 'null' ||
            selectedObject.address.location_notes === null ||
            selectedObject.address.location_notes === undefined ||
            selectedObject.address.location_notes === 'undefined'
            ? ''
            : selectedObject.address.location_notes),
      selectedcouriertypelocation:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.selectedcouriertypelocation === '' ||
            selectedObject.address.selectedcouriertypelocation === 'null' ||
            selectedObject.address.selectedcouriertypelocation === null ||
            selectedObject.address.selectedcouriertypelocation === undefined ||
            selectedObject.address.selectedcouriertypelocation === 'undefined'
            ? ''
            : selectedObject.address.selectedcouriertypelocation),
      shelf:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.shelf === '' ||
            selectedObject.address.shelf === 'null' ||
            selectedObject.address.shelf === null ||
            selectedObject.address.shelf === undefined ||
            selectedObject.address.shelf === 'undefined'
            ? ''
            : selectedObject.address.shelf),
      country:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.country === '' ||
            selectedObject.address.country === 'null' ||
            selectedObject.address.country === null ||
            selectedObject.address.country === undefined ||
            selectedObject.address.country === 'undefined'
            ? ''
            : selectedObject.address.country),
      alternetAgents: selectedObject && selectedObject.alternetAgents,
      patient_id: selectedObject && selectedObject.patient_id,
      patient_signature: selectedObject && selectedObject.signature_url,
      patient_signature_time: selectedObject && selectedObject.signature_date,
      customer_pkid: selectedObject && selectedObject.id,
      IsPayrollDeduct: selectedObject && selectedObject.payroll_deduct,
      PatientDeliveryAddress: selectedObject && selectedObject.addressesMapping,
      docOneHash:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docone_hash,
      docOneLabel:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docone_label,
      docOneDataURL:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docone_url,
      docTwoHash:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_doctwo_hash,
      docTwoLabel:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_doctwo_label,
      docTwoDataURL:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_doctwo_url,
      docThreeHash:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docthree_hash,
      docThreeLabel:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docthree_label,
      docThreeDataURL:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docthree_url,
      preferLanguage: selectedObject.preferred_language,
      pin: selectedObject && selectedObject.pin,
      isPet: selectedObject && selectedObject.is_pet,
      customerLCpreview: selectedObject.legaldocs && selectedObject.legaldocs.signature_url ? ConsentPreview : null,
    };
    this.props.retrieveData(filteredObject)
    this.handleContextClose(event);
  };

  handleEdit = (event) => {
    const selectedObject = this.state.data.find(
      (x) => x.id === this.state.selectedRowId
    );

    const patientaccount = this.props.account.filter(
      (x) => x.id === selectedObject.parent_account_id
    );
    ConsentPreview =
      patientaccount &&
      patientaccount[0].legal_compliance &&
      patientaccount[0].legal_compliance.legal_compliance_doctwo_url;
    const filteredObject =
    {
      location_id: selectedObject.location_id,
      expanded: 'panel0',
      selectedTab: 0,
      showNewUserDialog: true,
      patient_notes: selectedObject.notes,
      operation: 'Edit',
      user: selectedObject,
      parent_account_id: selectedObject.parent_account_id,
      first_name: selectedObject.first_name,
      last_name: selectedObject.last_name,
      email: selectedObject.contacts[0].email,
      avatarPreview: selectedObject.picture_url,
      phone: selectedObject.contacts && selectedObject.contacts[0].phone,
      dob: selectedObject.dob_str ? selectedObject.dob_str : null,
      box_id: selectedObject.box_id ? selectedObject.box_id : null,
      Nemail: selectedObject.email_notification,
      Nsms: selectedObject.sms_notification,
      Npush: selectedObject.push_notification,
      ada: selectedObject.ada_compitible,
      LCPreview:
        selectedObject.legaldocs &&
        selectedObject.legaldocs.docmanual_policy_url,
      IsActive:
        selectedObject.legaldocs && selectedObject.legaldocs.is_active,
      IsConsent: selectedObject.is_consent_accepted,
      signature:
        selectedObject.legaldocs && selectedObject.legaldocs.signature_url,
      signature_time:
        selectedObject.legaldocs && selectedObject.legaldocs.signature_date,
      consent_id: selectedObject.legaldocs && selectedObject.legaldocs.id,
      Locations: selectedObject.customerLocations,
      address1:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.address_line_1 === '' ||
            selectedObject.address.address_line_1 === 'null' ||
            selectedObject.address.address_line_1 === null ||
            selectedObject.address.address_line_1 === undefined ||
            selectedObject.address.address_line_1 === 'undefined'
            ? ''
            : selectedObject.address.address_line_1),
      address2:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.address_line_2 === '' ||
            selectedObject.address.address_line_2 === 'null' ||
            selectedObject.address.address_line_2 === null ||
            selectedObject.address.address_line_2 === undefined ||
            selectedObject.address.address_line_2 === 'undefined'
            ? ''
            : selectedObject.address.address_line_2),
      zip:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.zip === '' ||
            selectedObject.address.zip === 'null' ||
            selectedObject.address.zip === null ||
            selectedObject.address.zip === undefined ||
            selectedObject.address.zip === 'undefined'
            ? ''
            : selectedObject.address.zip),
      state:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.state === '' ||
            selectedObject.address.state === 'null' ||
            selectedObject.address.state === null ||
            selectedObject.address.state === undefined ||
            selectedObject.address.state === 'undefined'
            ? ''
            : selectedObject.address.state),
      city:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.city === '' ||
            selectedObject.address.city === 'null' ||
            selectedObject.address.city === null ||
            selectedObject.address.city === undefined ||
            selectedObject.address.city === 'undefined'
            ? ''
            : selectedObject.address.city),
      room_no:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.room_no === '' ||
            selectedObject.address.room_no === 'null' ||
            selectedObject.address.room_no === null ||
            selectedObject.address.room_no === undefined ||
            selectedObject.address.room_no === 'undefined'
            ? ''
            : selectedObject.address.room_no),
      bed_no:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.bed_no === '' ||
            selectedObject.address.bed_no === 'null' ||
            selectedObject.address.bed_no === null ||
            selectedObject.address.bed_no === undefined ||
            selectedObject.address.bed_no === 'undefined'
            ? ''
            : selectedObject.address.bed_no),
      source_location:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.source_location === '' ||
            selectedObject.address.source_location === 'null' ||
            selectedObject.address.source_location === null ||
            selectedObject.address.source_location === undefined ||
            selectedObject.address.source_location === 'undefined'
            ? ''
            : selectedObject.address.source_location),
      destination_location:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.destination_location === '' ||
            selectedObject.address.destination_location === 'null' ||
            selectedObject.address.destination_location === null ||
            selectedObject.address.destination_location === undefined ||
            selectedObject.address.destination_location === 'undefined'
            ? ''
            : selectedObject.address.destination_location),
      location_notes:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.location_notes === '' ||
            selectedObject.address.location_notes === 'null' ||
            selectedObject.address.location_notes === null ||
            selectedObject.address.location_notes === undefined ||
            selectedObject.address.location_notes === 'undefined'
            ? ''
            : selectedObject.address.location_notes),
      selectedcouriertypelocation:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.selectedcouriertypelocation === '' ||
            selectedObject.address.selectedcouriertypelocation === 'null' ||
            selectedObject.address.selectedcouriertypelocation === null ||
            selectedObject.address.selectedcouriertypelocation ===
            undefined ||
            selectedObject.address.selectedcouriertypelocation === 'undefined'
            ? ''
            : selectedObject.address.selectedcouriertypelocation),
      shelf:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.shelf === '' ||
            selectedObject.address.shelf === 'null' ||
            selectedObject.address.shelf === null ||
            selectedObject.address.shelf === undefined ||
            selectedObject.address.shelf === 'undefined'
            ? ''
            : selectedObject.address.shelf),
      country:
        selectedObject.address &&
        (selectedObject.address === null || selectedObject.address === 'null'
          ? ''
          : selectedObject.address.country === '' ||
            selectedObject.address.country === 'null' ||
            selectedObject.address.country === null ||
            selectedObject.address.country === undefined ||
            selectedObject.address.country === 'undefined'
            ? ''
            : selectedObject.address.country),
      alternetAgents: selectedObject && selectedObject.alternetAgents,
      patient_id: selectedObject && selectedObject.patient_id,
      member_id: selectedObject && selectedObject.member_id,
      customer_pkid: selectedObject && selectedObject.id,
      patient_signature: selectedObject && selectedObject.signature_url,
      patient_signature_time: selectedObject && selectedObject.signature_date,
      IsPayrollDeduct: selectedObject && selectedObject.payroll_deduct,
      PatientDeliveryAddress:
        selectedObject && selectedObject.addressesMapping,
      docOneHash:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docone_hash,
      docOneLabel:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docone_label,
      docOneDataURL:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docone_url,
      docTwoHash:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_doctwo_hash,
      docTwoLabel:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_doctwo_label,
      docTwoDataURL:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_doctwo_url,
      docThreeHash:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docthree_hash,
      docThreeLabel:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docthree_label,
      docThreeDataURL:
        patientaccount &&
        patientaccount[0] &&
        patientaccount[0].legal_compliance &&
        patientaccount[0].legal_compliance.legal_compliance_docthree_url,
      preferLanguage: selectedObject.preferred_language,
      pin: selectedObject && selectedObject.pin,
      isPet: selectedObject && selectedObject.is_pet,
      customerLCpreview: selectedObject.legaldocs && selectedObject.legaldocs.signature_url ? ConsentPreview : null,
    };
    this.props.retrieveData(filteredObject)
    this.handleContextClose(event);
  };

  confirmDelete = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        deleteDialogOpen: true,
        forDeletion: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  deleteConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        deleteDialogOpen: false,
        selectedRowId: null,
        forDeletion: null,
      });
    }
  };

  deleteConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDelete(event);
    }
    this.setState({ deleteDialogOpen: false });
  };

  handleDelete = (event) => {
    this.setState({ loader: true });
    const rowIdToDelete = this.state.selectedRowId;
    fetch(process.env.REACT_APP_BASEURL + 'customers/' + rowIdToDelete, {
      method: 'DELETE',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
    })
      .then((response) => {
        return response.json();
      })
      .then((result) => {
        if (result && result.status === 400) {
          toast.error(result.message);
          this.setState({ loader: false });
          this.handleContextClose(event);
        } else {
          this.setState({ loader: false });
          this.handleContextClose(event);
          const newData = this.state.data.filter((x) => x.id !== rowIdToDelete);
          this.setState({
            data: JSON.parse(JSON.stringify(newData)),
            selected: [],
            selectedRowId: null,
          });
          const filteredObject = {
            data: JSON.parse(JSON.stringify(newData)),
            selected: [],
            selectedRowId: null,
          }
          this.props.retrieveData(filteredObject)
          this.handleContextClose(event);
          toast.success(this.props.t('Toast.Success.PatientRemoved'));
          this.props.params.api.refreshServerSide();
        }
      });
  };

  confirmDisable = () => {
    if (this.state.selectedRowId) {
      this.setState({
        disableDialogOpen: true,
        forDisable: this.state.data.filter(
          (x) => x.id === this.state.selectedRowId
        ),
      });
    } else {
      this.setState({
        disableDialogOpen: true,
        forDisable: this.state.data.filter(
          (x) => this.state.selected.indexOf(x.id) > -1
        ),
      });
    }
  };

  disableConfirmClose = (event) => {
    if (this.state.selectedRowId) {
      this.setState({
        disableDialogOpen: false,
        selectedRowId: null,
        forDisable: null,
      });
      this.handleContextClose(event);
    } else {
      this.setState({
        disableDialogOpen: false,
        selectedRowId: null,
        forDisable: null,
      });
    }
  };

  disableConfirmed = (event) => {
    if (this.state.selectedRowId) {
      this.handleDisable(event);
    }
    this.setState({ disableDialogOpen: false });
    toast.success(
      `${this.props.t('Toast.Patient')} ${this.state && this.state.disabledText}${this.props.t('Toast.Success')}`
    );
  };

  handleDisable = (event) => {
    this.setState({ loader: true });
    const rowIdToDisable = this.state.selectedRowId;
    const DisUser = {
      id: rowIdToDisable,
      is_enabled:
        this.state && this.state.disabledText.toLowerCase() === 'disable'
          ? false
          : true,
    };
    const result = fetch(process.env.REACT_APP_BASEURL + 'disable/patient/', {
      method: 'post',
      withCredentials: true,
      headers: {
        'Content-Type': 'application/json',
        Authorization:
          'Bearer ' +
          JSON.parse(sessionStorage.getItem('user')).signInUserSession.idToken
            .jwtToken,
      },
      body: JSON.stringify(DisUser),
    }).then((response) => {
      try {
        return response.text();
      } catch (error) {
        this.setState({ loader: false });
        return null;
      }
    });
    result.then((result) => {
      this.setState({ loader: false });
      this.handleContextClose(event);
      this.props.params.api.refreshServerSide();
    });
  };

  render() {
    const { classes, t, params } = this.props;
    const { anchorEl, patientview, patientedit, patientdelete, disabledText, deleteDialogOpen, forDeletion, disableDialogOpen, forDisable } = this.state;
    const contextOpen = Boolean(anchorEl)

    return (
      <div>
        <Dialog
          open={deleteDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>
            {t('Patient.AreYouSureToDelete')}
          </DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Patient.AreYouSureToDeletePatient')} :
              <ul>
                {forDeletion && forDeletion.map(function (a) {
                    return <li>{a.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.deleteConfirmClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Patient.CancelButton')}
            </Button>
            <Button
              onClick={this.deleteConfirmed}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
              {t('Patient.DeleteActions')}
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={disableDialogOpen || false}
          aria-labelledby='alert-dialog-title'
          aria-describedby='alert-dialog-description'
        >
          <DialogTitle id='alert-dialog-title'>{`${t(
            'Patient.AreYouSureTo'
          )}  ${disabledText}?`}</DialogTitle>
          <DialogContent>
            <DialogContentText id='alert-dialog-description'>
              {t('Patient.AreYouSureTo')}{' '}
              {disabledText} ${t('Patient.patients')}:
              <ul>
                {forDisable &&
                  forDisable.map(function (x) {
                    return <li>{x.name}</li>;
                  })}
              </ul>
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.disableConfirmClose}
              color='primary'
              className={classes.primaryButton}
            >
              {t('Patient.CancelButton')}
            </Button>
            <Button
              onClick={this.disableConfirmed}
              color='primary'
              autoFocus
              className={classes.primaryButton}
            >
              {t('Patient.YES')}
            </Button>
          </DialogActions>
        </Dialog>
        <IconButton
          aria-label='More'
          aria-owns={contextOpen ? 'long-menu' : null}
          aria-haspopup='true'
          onClick={(event) => this.handleContextClick(event, params.data)}
        >
          <MoreVertIcon style={{ fontSize: 20 }} />
        </IconButton>
        <Menu
          id='long-menu'
          anchorEl={anchorEl}
          open={contextOpen}
          onClose={this.handleContextClose}
          PaperProps={{
            style: {
              maxHeight: ITEM_HEIGHT * 4.5,
              width: 200,
            },
          }}
        >
          {patientview === true ? (
            <MenuItem
              key='view'
              onClick={this.handleView}
              sx={{ height: '40px' }}
            >
              <ListItemText>{t('Patient.ViewActions')}</ListItemText>
            </MenuItem>
          ) : (
            ''
          )}
          {patientedit === true ? (
            <MenuItem
              key='edit'
              onClick={this.handleEdit}
              sx={{ height: '40px' }}
            >
              <ListItemText>{t('Patient.EditActions')}</ListItemText>
            </MenuItem>
          ) : (
            ''
          )}
          {patientdelete === true ? (
            <MenuItem
              key='delete'
              onClick={this.confirmDelete}
              sx={{ height: '40px' }}
            >
              <ListItemText>{t('Patient.DeleteActions')}</ListItemText>
            </MenuItem>
          ) : (
            ''
          )}
          <MenuItem
            key='disabled'
            onClick={this.confirmDisable}
            sx={{ height: '40px' }}
          >
            <ListItemText>
              {disabledText}
            </ListItemText>
          </MenuItem>
        </Menu>
      </div>
    )
  }
}

export default VerticalMenu;


// WEBPACK FOOTER //
// ./src/components/patient-list/ActionCellRenderer.js